"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInputTranslations = exports.NumberInputTestSelectors = exports.NumberInputTranslationIds = void 0;
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const NumberInput_1 = tslib_1.__importStar(require("carbon-components-react/es/components/NumberInput/NumberInput"));
const StringResource_1 = require("../nls/StringResource");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'NumberInput';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const DECREMENT = StringResource_1.stringResource.get('numberInputDecrement');
const INCREMENT = StringResource_1.stringResource.get('numberInputIncrement');
const MSG_BLANK = StringResource_1.stringResource.get('numberInputMsgBlank');
const CarbonNumberInputTranslationIds = NumberInput_1.translationIds !== null && NumberInput_1.translationIds !== void 0 ? NumberInput_1.translationIds : {
    'increment.number': 'increment.number',
    'decrement.number': 'decrement.number',
};
const TRANSLATE_WITH_ID = {
    [CarbonNumberInputTranslationIds['decrement.number']]: DECREMENT,
    [CarbonNumberInputTranslationIds['increment.number']]: INCREMENT,
};
const NumberInput = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid, id, translateWithId } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid', "id", "translateWithId"]);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : DEFAULT_TID,
        id: id !== null && id !== void 0 ? id : (0, utils_1.getUniqueId)(DISPLAY_NAME),
        translateWithId: translateWithId !== null && translateWithId !== void 0 ? translateWithId : ((translateId) => TRANSLATE_WITH_ID[translateId]),
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(NumberInput_1.default, Object.assign({}, otherCarbonProps, mappedProps));
});
NumberInput.propTypes = {
    'data-tid': prop_types_1.default.string,
    id: prop_types_1.default.string,
    translateWithId: prop_types_1.default.func,
};
NumberInput.displayName = DISPLAY_NAME;
exports.default = NumberInput;
exports.NumberInputTranslationIds = CarbonNumberInputTranslationIds;
exports.NumberInputTestSelectors = {
    decrement: 'button.down-icon',
    increment: 'button.up-icon',
    input: 'input',
    message: '#number-input-error-id',
};
exports.NumberInputTranslations = {
    blank: MSG_BLANK,
    decrement: DECREMENT,
    increment: INCREMENT,
};
